export default "__VITE_ASSET__e8a4b566__"